var cake_submission_form = ( function( $ ) {

	var $form;

	var _init = function() {
		$form = $( '#cake_submission_form' );

		_setup_tutorials_lazy_load();
	};

	var _setup_tutorials_lazy_load = function() {
		var $select = $form.find( 'select#field_tutorial' );

		$select.select2( {
			dropdownParent: $select.closest( '.field-wrap' ),
			ajax: {
				url: ScriptData.ajaxurl,
				method: 'GET',
				dataType: 'json',
				delay: 250,
				data: _tutorials_data
			}
		} );
	};

	var _tutorials_data = function( params ) {
		return {
			q: params.term || '',
			page: params.page || 1,
			amount: 20,
			nonce: ScriptData.crate_tutorials_field_nonce,
			action: 'crate_tutorials_field'
		}
	};

	if ( $( '#cake_submission_form' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = cake_submission_form;